import angular from 'angular';
import productComparisonItem from './productComparisonItem';

export default angular.module(
  'scenes.loanAppSections.scenes.loanProductFinder.components',
  [productComparisonItem],
).name;
